<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 5.00098C22.0749 5.00098 26.9995 9.92563 26.9995 16.0005C26.9995 22.0754 22.0749 27 16 27C9.92514 27 5.00049 22.0754 5.00049 16.0005C5.00049 9.92563 9.92514 5.00098 16 5.00098ZM24.9995 16.0005C24.9995 11.0302 20.9703 7.00098 16 7.00098C11.0297 7.00098 7.00049 11.0302 7.00049 16.0005C7.00049 20.9708 11.0297 25 16 25C20.9703 25 24.9995 20.9708 24.9995 16.0005Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.6257 14.0151L15.7901 19.062C15.5732 19.2884 15.2733 19.4164 14.9598 19.4164C14.6463 19.4164 14.3463 19.2884 14.1294 19.062L11.3738 16.1861L13.0345 14.5949L14.9597 16.6042L18.965 12.4239L20.6257 14.0151Z"
        />
    </svg>
</template>
